// import Swiper JS
import Swiper, {EffectFade, Autoplay, Navigation} from 'swiper';

Swiper.use([EffectFade, Autoplay, Navigation]);

document.addEventListener("DOMContentLoaded", function() {
  let swiper = new Swiper(".bannerSwiper", {
      slidesPerView: 1,
      loop: true,
      effect: "fade",
      speed: 1500,
      autoplay: {
          delay: 3500,
          disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
  });

  // if(document.querySelector('.random-words__word')){
  //   let phrases = [
  //     'Plafonds suspendus', 
  //     'Cloisons industrielles / Salles blanches', 
  //     'Planchers techniques', 
  //     'Gardes-corps aluminium',
  //     'Cloisons amovibles'
  //   ],
  //   text = document.querySelector('.random-words__word'), 
  //   count = 0;
    
  //   setInterval(function() {
  //     count ++;
  //     text.textContent = phrases[count % phrases.length];
  //   }, 4000);
  // }
});

